import { render } from "./RichLabel.vue?vue&type=template&id=536e4648"
import script from "./RichLabel.vue?vue&type=script&lang=js"
export * from "./RichLabel.vue?vue&type=script&lang=js"

import "./RichLabel.vue?vue&type=style&index=0&id=536e4648&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__